export const REPORT_GENERATE_INITIAL_YAML = `# This is the initial template used for customizing your code documentation and visualization.
# Static pages rendered at the beginning of the document
# You can describe your system here using **Markdown**, embed graphs, and use placeholders like \`'{{file_name}}'\`.
# You can use {{variables}} like {{file_name}}, {{method_name}}, etc., which will be dynamically replaced.
# You can also use [[GRAPH]]...[[/GRAPH]] blocks to define or embed graph structures., you can use [[GRAPH]]{{graph_field}}[[/GRAPH]]
## Example graph:
#
# [[GRAPH]]
# {
# "nodes": [
#    {
#    "id": "main",
#    "data": { "label": "main()" },
#    "position": { "x": 0, "y": 0 },
#    "type": "default"
#    },
#    {
#    "id": "init",
#    "data": { "label": "initConfig()" },
#    "position": { "x": -150, "y": 150 },
#    "type": "default"
#    },
# ],
#"edges": [
#    { "id": "e1", "source": "main", "target": "init" },
#]
#}
#[[/GRAPH]]
# For filter files/folders, you can use exactly names, regular expressions, or matches like this:
#  - /regex/ - it will be treated as a regular expression
#  - ^ – asserts the start of the string (i.e., the beginning of the folder name).
#  - test_ – matches the literal prefix "test_".
#  - [a-z]+ – matches one or more lowercase letters from a to z.
#  - $ – asserts the end of the string (i.e., the folder name must end after the lowercase letters).

# Folder-specific templates (by name pattern)
# folders:
#  "*lib*":
#    Summary: |
#      ## Folder: {{path}}

# File-specific templates (by pattern)
# files:
#  "*lib*":
#    Summary: |
#      ## Folder: {{path}}

# Method-specific templates (for each method found)
#methods:
#  "*": |
#      #### Method: {{method_name}}
#            This method is extracted from the file '{{file_name}}'.
#      ---
#      Method ID: {{method_id}}

pages:
  Dashboard: |
    # 📕 Introduction

    Welcome to your project documentation.
    
  BRD document: |
  
    {{brd_description}}

  Project overview: |
  
    {{project_description}}
  
  Technical details: |
  
    {{technical_details_description}}

  Usage: |
    ## How to Use

    - Navigate through folders and files
    - Click methods to see implementation details
    - Use this template to auto-generate documentation

folders:
  "*":
    Summary: |
      ## Folder: {{path}}

      This section documents all services inside the folder '{{path}}'.
      Each service in this folder may include business logic and helpers.

files:
  "*":
    Summary: |
      ## File: {{file_name}}

      This TypeScript file contains important code elements.
      End of file '{{file_name}}'

    Code: |
        ### File Structure

        Below is a graph representing the structure of this file:

methods:
  "*": |
      #### Method: {{method_id}}
            This method is extracted from the file '{{file_name}}'.

`;
